import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
	selector: 'evaluate-component',
	templateUrl: './evaluate.html',
	styleUrls: ['./evaluate.css']
})
export class ComponentEvaluate implements OnInit, AfterViewInit {

	@Input() context : string //追问内容
	@Input() myComment : string //顾问第一次点评
	@Input() myQuetionComment : string //顾问第二次点评
	@Input() excellentFlag : number //是否为优秀作业

	constructor(
		private route: ActivatedRoute,
		private router: Router,) {
		}
    ngOnInit() {
		console.log(this.context)
	}
		
	ngAfterViewInit(){
		
	}

	
}


// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-evaluate/evaluate.ts